import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";

import PieReport from "./PieReport";
import TabsReport from "./TabsReport";
import useToggle from "../../../../Hooks/useToggle";
import ModalPicker from "../../../../utils/DatesPicker/ModalPicker";

import URLS from "./dictionaries/urls";
import Table from "./components/Table";
import fetchData from "./components/fetchData";
import { API_DATE_FORMAT } from "../../../../utils/Dates";

const UsersReports = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [activateTab, setActiveTab] = useState(0);
  const [modal, toggleModal] = useToggle();
  const [isFiltered, setIsFiltered] = useToggle();
  const [dates, setDates] = useState(["", ""]);
  const currentPage = useRef(0);
  const [usersCount, setUsersCount] = useState({
    totalUsersActive: 0,
    totalUsersRejected: 0,
    totalUsersPending: 0,
  });

  /**
   *
   * @param {Date} dateStart
   * @param {Date} dateEnd
   */
  function filterByDate(dateStart, dateEnd) {
    setDates([
      moment(dateStart).format(API_DATE_FORMAT),
      moment(dateEnd).format(API_DATE_FORMAT),
    ]);

    toggleModal();
    setIsFiltered();
  }

  const getData = useCallback(
    async ({ page = 0, is_mounted = true }) => {
      const [startDate, endDate] = dates;
      const { data } = await fetchData(URLS[activateTab].base, {
        params: {
          start: startDate != "" ? startDate : "",
          end: endDate != "" ? endDate : "",
          page: page,
        },
      });

      if (!is_mounted) return;

      setData(data);
    },
    [setData, activateTab, dates, URLS]
  );

  useEffect(() => {
    let is_mounted = true;

    getData({ is_mounted });

    return () => {};
  }, [activateTab, dates, URLS]);

  useEffect(() => {
    async function getGraph() {
      const [startDate, endDate] = dates;
      const { data } = await fetchData("reportes/admin/users/count", {
        params: {
          start: startDate != "" ? startDate : "",
          end: endDate != "" ? endDate : "",
        },
      });

      setUsersCount(data);
    }

    getGraph();
  }, [dates, setUsersCount]);

  return (
    <>
      <main className="container">
        <div className="card mt-3 ">
          <div className="card-body">
            <h3>Reporte de Usuarios</h3>

            <div className="d-flex justify-content-end  p-3">
              <button
                className="btn-deg"
                style={{
                  width: "fit-content",
                  padding: "5px 10px",
                  marginRight: "1rem",
                }}
                onClick={toggleModal}
              >
                Filtrar por Fecha
              </button>

              <button
                className="btn-deg"
                style={{ width: "fit-content", padding: "5px 5px" }}
                onClick={() => history.push("/admin/reports")}
              >
                <i className="fas fa-arrow-left"></i> Atrás
              </button>
            </div>

            {isFiltered && (
              <div
                onClick={() => {
                  setDates(["", ""]);
                  setIsFiltered();
                }}
                role="button"
                className="text-grey d-flex justify-content-end  p-3"
              >
                <i className="fas fa-times mt-1"></i>{" "}
                <span style={{ marginLeft: "1rem" }}>Clear Filter</span>
              </div>
            )}

            <div className="row mt-3">
              <TabsReport
                dates={dates}
                data={data}
                onTabChange={(key) => setActiveTab(key)}
              >
                <Table
                  data={data}
                  onPageNext={() => {
                    getData({
                      page: currentPage.current + 1,
                    });

                    currentPage.current = currentPage.current + 1;
                  }}
                  onPagePrev={() => {
                    if (currentPage.current === 0) return;

                    getData({
                      page: currentPage.current - 1,
                    });

                    currentPage.current = currentPage.current - 1;
                  }}
                />
              </TabsReport>

              <PieReport {...usersCount} />
            </div>
          </div>
        </div>
      </main>

      <ModalPicker show={modal} onHide={toggleModal} onOk={filterByDate} />
    </>
  );
};

export default UsersReports;
